module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1e69968a42d645e2f4ba4db187aa73d8.png";